import i18n from 'i18next';
import { MediaTypes } from '../common/enums/MediaTypes';

export const localizeMediaType = (mediaType: MediaTypes): string => {
  if (!mediaType) return '';
  return i18n.t(`mediaTypes.${mediaType}`);
};
